import messages from '../../../locale/messages';
import { inputTextLimit, inputDescLimit } from '../../../helpers/textRestriction';
import { isEmpty, exceedsLimit } from '../../../helpers/Validation/validationHelpers';

const validate = (values) => {
  const errors = {};

  // Meta Title
  if (isEmpty(values.metaTitle)) {
    errors.metaTitle = messages.required;
  } else if (exceedsLimit(values.metaTitle, inputTextLimit)) {
    errors.metaTitle = messages.inputFieldRestriction;
  }

  // Meta Description
  if (isEmpty(values.metaDescription)) {
    errors.metaDescription = messages.required;
  } else if (exceedsLimit(values.metaDescription, inputDescLimit)) {
    errors.metaDescription = messages.descriptionFieldRestriction;
  }

  // Footer Category
  if (isEmpty(values.footerCategory)) {
    errors.footerCategory = messages.required;
  }

  // Page Title
  if (isEmpty(values.pageTitle)) {
    errors.pageTitle = messages.required;
  } else if (exceedsLimit(values.pageTitle, inputTextLimit)) {
    errors.pageTitle = messages.inputFieldRestriction;
  }

  // Page URL
  if (isEmpty(values.pageUrl)) {
    errors.pageUrl = messages.required;
  } else {
    const url = values.pageUrl;
    const hasInvalidChars = /[\/?&]/.test(url);
    try {
      decodeURIComponent(url);
    } catch {
      errors.pageUrl = messages.invalidPageUrl;
    }
    if (hasInvalidChars) {
      errors.pageUrl = messages.invalidPageUrl;
    }
  }

  // Content
  if (isEmpty(values.content || values?.content == '<p><br></p>' || values?.content == '<p> </p>')) {
    errors.content = messages.required;
  }

  return errors;
};

export default validate;
